import React from "react";

function Courses() {
  return (
    <>
      {/*  All Courses Start **/}
      <div id="courses" className="section section-padding-02">
        <div className="container">
          {/*  All Courses Top Start **/}
          <div className="courses-top">
            {/*  Section Title Start **/}
            <div className="section-title shape-01">
              <h2 className="main-title">
                All <span>Courses</span> From Techijack
              </h2>
            </div>
            {/*  Section Title End **/}

            {/*  Courses Search Start **/}
            <div className="courses-search">
              <a className="btn btn-primary btn-hover-dark"
                href="https://app.techijack.com/"
                target={"_blank"} rel="noreferrer"
              >
                Start A Course
              </a>
            </div>
            {/*  Courses Search End **/}
          </div>
          {/*  All Courses Top End **/}

          {/*  All Courses tab content Start **/}
          <div className="tab-content courses-tab-content">
            <div className="tab-pane fade show active" id="tabs1">
              {/*  All Courses Wrapper Start **/}
              <div className="courses-wrapper">
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    {/*  Single Courses Start **/}
                    <div className="single-courses">
                      <div className="courses-images">
                        <a href="https://app.techijack.com/">
                          <img
                            src="assets/images/courses/exchange_serveradmin_course.jpg"
                            alt="Courses"
                          />
                        </a>
                      </div>
                      <div className="courses-content">
                        <div className="courses-author">
                          <div className="author">
                            <div className="author-thumb">
                              <a href="https://app.techijack.com/">
                                <img
                                  src="assets/images/author/techijack.png"
                                  alt="Author"
                                />
                              </a>
                            </div>
                            <div className="author-name">
                              <a className="name" href="https://app.techijack.com/">
                                Techijack
                              </a>
                            </div>
                          </div>
                          <div className="tag">
                            <a href="https://app.techijack.com/">Exchange Server</a>
                          </div>
                        </div>

                        <h4 className="title">
                          <a href="https://app.techijack.com/newApp/store/course/226362?section=overview">
                          Exchange Server Administration 20345 1-B
                          </a>
                        </h4>
                        <div className="courses-meta">
                          <span>
                            {" "}
                            <i className="icofont-clock-time"></i> 10 hr
                          </span>
                          <span>
                            {" "}
                            <i className="icofont-read-book"></i> 98 Lectures{" "}
                          </span>
                        </div>
                        <div className="courses-price-review">
                          <div className="courses-price">
                            <span className="sale-parice">$109.99</span>
                            <span className="old-parice">$189.00</span>
                          </div>
                          <div className="courses-review">
                            <span className="rating-count">4.9</span>
                            <span className="rating-star">
                              <span
                                className="rating-bar"
                                
                              ></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  Single Courses End **/}
                  </div>
                  <div className="col-lg-4 col-md-6">
                    {/*  Single Courses Start **/}
                    <div className="single-courses">
                      <div className="courses-images">
                        <a href="https://app.techijack.com/newApp/store/course/226582?section=overview">
                          <img
                            src="assets/images/courses/exchange2016-2019migration.jpg"
                            alt="Courses"
                          />
                        </a>
                      </div>
                      <div className="courses-content">
                        <div className="courses-author">
                          <div className="author">
                            <div className="author-thumb">
                              <a href="https://app.techijack.com/">
                                <img
                                  src="assets/images/author/techijack.png"
                                  alt="Author"
                                />
                              </a>
                            </div>
                            <div className="author-name">
                              <a className="name" href="https://app.techijack.com/">
                               TechiJack
                              </a>
                            </div>
                          </div>
                          <div className="tag">
                            <a href="https://app.techijack.com/">Exchange Server</a>
                          </div>
                        </div>

                        <h4 className="title">
                          <a href="https://app.techijack.com/">
                          MIGRATING EXCHANGE 2016 TO 2019
                          </a>
                        </h4>
                        <div className="courses-meta">
                          <span>
                            {" "}
                            <i className="icofont-clock-time"></i> 51 mins
                          </span>
                          <span>
                            {" "}
                            <i className="icofont-read-book"></i> 3 Lectures{" "}
                          </span>
                        </div>
                        <div className="courses-price-review">
                          <div className="courses-price">
                            <span className="sale-parice">$39.99</span>
                          </div>
                          <div className="courses-review">
                            <span className="rating-count">4.9</span>
                            <span className="rating-star">
                              <span
                                className="rating-bar"
                                
                              ></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  Single Courses End **/}
                  </div>
                  <div className="col-lg-4 col-md-6">
                    {/*  Single Courses Start **/}
                    <div className="single-courses">
                      <div className="courses-images">
                        <a href="https://app.techijack.com/newApp/store/course/226582?section=overview">
                          <img
                            src="assets/images/courses/courses-03.jpg"
                            alt="Courses"
                          />
                        </a>
                      </div>
                      <div className="courses-content">
                        <div className="courses-author">
                          <div className="author">
                            <div className="author-thumb">
                              <a href="https://app.techijack.com/">
                                <img
                                  src="assets/images/author/techijack.png"
                                  alt="Author"
                                />
                              </a>
                            </div>
                            <div className="author-name">
                              <a className="name" href="https://app.techijack.com/">
                               TechiJack
                              </a>
                            </div>
                          </div>
                          <div className="tag">
                            <a href="https://app.techijack.com/">Exchange Server</a>
                          </div>
                        </div>

                        <h4 className="title">
                          <a href="https://app.techijack.com/">
                          DEPLOYING HYBRID EXCHANGE & DECOMMISSIONING ON PREM EXCHANGE
                          </a>
                        </h4>
                        <div className="courses-meta">
                          <span>
                            {" "}
                            <i className="icofont-clock-time"></i> 22 mins
                          </span>
                          <span>
                            {" "}
                            <i className="icofont-read-book"></i> 13 Lectures{" "}
                          </span>
                        </div>
                        <div className="courses-price-review">
                          <div className="courses-price">
                            <span className="sale-parice">$37.00</span>
                          </div>
                          <div className="courses-review">
                            <span className="rating-count">4.9</span>
                            <span className="rating-star">
                              <span
                                className="rating-bar"
                                
                              ></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  Single Courses End **/}
                  </div>
                  <div className="col-lg-4 col-md-6">
                    {/*  Single Courses Start **/}
                    <div className="single-courses">
                      <div className="courses-images">
                        <a href="https://app.techijack.com/newApp/store/course/226582?section=overview">
                          <img
                            src="assets/images/courses/migrating-hyper-v-azure.jpg"
                            alt="Courses"
                          />
                        </a>
                      </div>
                      <div className="courses-content">
                        <div className="courses-author">
                          <div className="author">
                            <div className="author-thumb">
                              <a href="https://app.techijack.com/">
                                <img
                                  src="assets/images/author/techijack.png"
                                  alt="Author"
                                />
                              </a>
                            </div>
                            <div className="author-name">
                              <a className="name" href="https://app.techijack.com/">
                               TechiJack
                              </a>
                            </div>
                          </div>
                          <div className="tag">
                            <a href="https://app.techijack.com/">Exchange Server</a>
                          </div>
                        </div>

                        <h4 className="title">
                          <a href="https://app.techijack.com/">
                          Migrating Hyper-V Virtual Machine To Microsoft Azure
                          </a>
                        </h4>
                        <div className="courses-meta">
                          <span>
                            {" "}
                            <i className="icofont-clock-time"></i> 41 mins
                          </span>
                          <span>
                            {" "}
                            <i className="icofont-read-book"></i> 2 Lectures{" "}
                          </span>
                        </div>
                        <div className="courses-price-review">
                          <div className="courses-price">
                            <span className="sale-parice">$42.99</span>
                          </div>
                          <div className="courses-review">
                            <span className="rating-count">4.9</span>
                            <span className="rating-star">
                              <span
                                className="rating-bar"
                                
                              ></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  Single Courses End **/}
                  </div>
                  <div className="col-lg-4 col-md-6">
                    {/*  Single Courses Start **/}
                    <div className="single-courses">
                      <div className="courses-images">
                        <a href="https://app.techijack.com/newApp/store/course/226582?section=overview">
                          <img
                            src="assets/images/courses/microsoft-azure 104-administer-Identity.jpg"
                            alt="Courses"
                          />
                        </a>
                      </div>
                      <div className="courses-content">
                        <div className="courses-author">
                          <div className="author">
                            <div className="author-thumb">
                              <a href="https://app.techijack.com/">
                                <img
                                  src="assets/images/author/techijack.png"
                                  alt="Author"
                                />
                              </a>
                            </div>
                            <div className="author-name">
                              <a className="name" href="https://app.techijack.com/">
                               TechiJack
                              </a>
                            </div>
                          </div>
                          <div className="tag">
                            <a href="https://app.techijack.com/">Microsoft Azure</a>
                          </div>
                        </div>

                        <h4 className="title">
                          <a href="https://app.techijack.com/">
                          Microsoft Azure 104 - Administer Identity
                          </a>
                        </h4>
                        <div className="courses-meta">
                          <span>
                            {" "}
                            <i className="icofont-clock-time"></i> 37 mins
                          </span>
                          <span>
                            {" "}
                            <i className="icofont-read-book"></i> 7 Lectures{" "}
                          </span>
                        </div>
                        <div className="courses-price-review">
                          <div className="courses-price">
                            <span className="sale-parice">$19.00</span>
                          </div>
                          <div className="courses-review">
                            <span className="rating-count">4.9</span>
                            <span className="rating-star">
                              <span
                                className="rating-bar"
                                
                              ></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  Single Courses End **/}
                  </div>
                </div>
              </div>
              {/*  All Courses Wrapper End **/}
            </div>
          </div>
          {/*  All Courses tab content End **/}

          {/*  All Courses BUtton Start **/}
          <div className="courses-btn text-center">
            <a
              href="https://app.techijack.com/"
              target={"_blank"} rel="noreferrer"
              className="btn btn-secondary btn-hover-primary"
            >
              Other Course
            </a>
          </div>
          {/*  All Courses BUtton End **/}
        </div>
      </div>
      {/*  All Courses End **/}
    </>
  );
}

export default Courses;
